
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salon/[subdomain]",
      function () {
        return require("private-next-pages/salon/[subdomain]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salon/[subdomain]"])
      });
    }
  